import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { http, safeGet } from "@/lib/api";

const SiteCtx = createContext(null);

const CONSENT_KEY = "ananawi_consent";

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [videos, setVideos] = useState({ videos: [], featured_id: "" });
  const [tracks, setTracks] = useState([]);
  const [coloring, setColoring] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [kits, setKits] = useState([]);
  const [user, setUser] = useState(undefined);
  const [consent, setConsentState] = useState(() => localStorage.getItem(CONSENT_KEY));
  const [player, setPlayer] = useState(null);
  const [party, setParty] = useState(false);

  const loadAll = useCallback(async () => {
    const [c, v, m, col, gal, kit] = await Promise.all([
      safeGet("/content", null),
      safeGet("/youtube", { videos: [], featured_id: "" }),
      safeGet("/music", { tracks: [] }),
      safeGet("/coloring", []),
      safeGet("/gallery", []),
      safeGet("/coloring?kind=kit", []),
    ]);
    setContent(c);
    setVideos({ videos: Array.isArray(v?.videos) ? v.videos : [], featured_id: v?.featured_id ?? "", manual_featured_id: v?.manual_featured_id ?? null });
    setTracks(Array.isArray(m?.tracks) ? m.tracks : []);
    setColoring(Array.isArray(col) ? col : []);
    setGallery(Array.isArray(gal) ? gal : []);
    setKits(Array.isArray(kit) ? kit : []);
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me", { params: { optional: 1 } });
      setUser(data ?? null);
    } catch (e) {
      console.error("auth/me failed", e);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    refreshUser();
  }, [refreshUser]);

  const setConsent = useCallback((v) => {
    localStorage.setItem(CONSENT_KEY, v);
    setConsentState(v);
  }, []);

  const logout = useCallback(async () => {
    try {
      await http.post("/auth/logout");
    } catch {}
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ content, videos, tracks, coloring, gallery, kits, user, setUser, refreshUser, logout, loadAll, consent, setConsent, player, setPlayer, party, setParty }),
    [content, videos, tracks, coloring, gallery, kits, user, refreshUser, logout, loadAll, consent, setConsent, player, party]
  );
  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
